import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../../dto/product';
import { Country } from '../../dto/country';
import { environment } from '../../../environments/environment';
import { Order } from '../../dto/order';
import { WebIdAction } from '../../dto/web-id-action';
import {ChangePaymentInfos} from '../../dto/change-payment-infos';
import {ChangePayment} from '../../dto/change-payment';
import {PartialOrderResult} from '../../dto/partial-order-result';
import {PartialOrderRequest} from '../../dto/partial-order-request';
import {ChangePaymentUpload} from '../../dto/change-payment-upload';
import {Company} from '../../dto/company';
import {AcceptReferral, AcceptReferralResult} from '../../dto/acceptReferral';

@Injectable()
export class OrderService {


  readonly apiPath = environment.baseUrl + 'order-assist/';
  readonly headers = {headers: new HttpHeaders({'No-Auth': 'True'})};

  constructor(
    private http: HttpClient,
  ) {
  }

  getChangePaymentInfos(orderId: string): Observable<any> {
    const params = new HttpParams()
      .set('p', orderId);
    return this.http.get(this.apiPath + 'change-payment-infos', {params}) as Observable<ChangePaymentInfos>;
  }


  getIdentUrl(orderKey: string): Observable<any> {
    return this.http.get(this.apiPath + 'ident-url/' + orderKey, {}) as Observable<object>;
  }

  confirmChangeEmail(token: string): Observable<any> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'change-email-confirmation', null, {params});
  }

  getChangePaymentUploadInfos(invoiceCode: string): Observable<any> {
    const params = new HttpParams()
      .set('p', invoiceCode);
    return this.http.get(this.apiPath + 'change-payment-upload-infos', {params}) as Observable<ChangePaymentInfos>;
  }

  changePayment(infos: ChangePayment): Observable<any> {
    return this.http.post(this.apiPath + 'change-payment', infos, this.headers);
  }

  changePaymentUpload(infos: ChangePaymentUpload): Observable<any> {
    return this.http.post(this.apiPath + 'change-payment-upload', infos, this.headers);
  }


  getCompany(path: string): Observable<any> {
    const params = new HttpParams()
      .set('path', path);
    return this.http.get(this.apiPath + 'companies', {params}) as Observable<Product[]>;
  }

  getProducts(id: number): Observable<any> {
    return this.http.get(this.apiPath + 'companies/' + id + '/products') as Observable<Product[]>;
  }

  getCountries(): Observable<Country[]> {
    return this.http.get(this.apiPath + 'countries') as Observable<Country[]>;
  }

  getNationalities(): Observable<any> {
    return this.http.get(this.apiPath + 'nationalities') as Observable<Country[]>;
  }

  getCountriesbyLang(lang: string): Observable<any> {
    return this.http.get(this.apiPath + 'countries/' + lang) as Observable<Country[]>;
  }

  getNationalitiesByLang(lang: string): Observable<any> {
    return this.http.get(this.apiPath + 'nationalities/' + lang) as Observable<Country[]>;
  }

  sendMsgConfCode(productId: number, phone: string): Observable<any> {
    return this.http.post(this.apiPath + 'phone-msg-conf', {productId, phone}, this.headers);
  }

  validateConfCode(phone: string, phoneCode: string): Observable<any> {
    return this.http.post(this.apiPath + 'validate-phone-msg-conf', {phone, phoneCode}, this.headers);
  }

  validateVoucherWithAmount(code, productId, wantCardName, paymentMethod): any {
    return this.http.post(this.apiPath + 'validate-voucher-code-2020', {
      code,
      productId,
      wantCardName,
      paymentMethod
    }, this.headers);
  }


  createOrder(order: Order): Observable<Order> {
    order.orderDate = new Date();
    return this.http.post(this.apiPath, order, {headers: {'skip-error-snack': 'true'}}) as Observable<Order>;
  }

  createWebIdTransaction(orderId: string): Observable<WebIdAction> {
    return this.http.post(this.apiPath + 'create-webid-transaction', {orderId}) as Observable<WebIdAction>;
  }

  validateEmail(productId: number, email: any): any {
    const params = new HttpParams()
      .set('productId', productId)
      .set('email', encodeURIComponent(email))
    ;
    return this.http.get(this.apiPath + 'check-email', {params});
  }

  checkDoubleData(order: Order): any {
    return this.http.post(this.apiPath + 'check-double-data', order) as Observable<any>;
  }

  updatePartialOrder(partialOrderRequest: PartialOrderRequest) {
    return this.http.post(this.apiPath + 'part', partialOrderRequest) as Observable<PartialOrderResult>;
  }

  getProductById(productId: number): Observable<Product> {
    return this.http.get(this.apiPath + 'product/' + productId) as Observable<Product>;
  }

  getCompanyById(companyId: number): Observable<Company> {
    return this.http.get(this.apiPath + 'company/' + companyId) as Observable<Company>;
  }

  acceptReferral(referralCode: string, phoneNumber: string): Observable<AcceptReferralResult> {

    const model = {
      phoneNumber,
      referralCode
    } as AcceptReferral;
    return this.http.post(this.apiPath + 'accept-referral', model) as Observable<AcceptReferralResult>;

  }

  acceptBrandReferral(referralCode: string, phoneNumber: string, vc: string|null): Observable<AcceptReferralResult> {

    const model = {
      phoneNumber,
      referralCode,
      vc
    } as AcceptReferral;
    return this.http.post(this.apiPath + 'accept-brand-referral', model) as Observable<AcceptReferralResult>;

  }

  getProductByBrandReferralCode(referralCode: string) {
    let params = new HttpParams()
      .set('ref', referralCode)
    ;
    return this.http.get(this.apiPath + 'products-by-brand-ref', {params}) as Observable<Product[]>;
  }
}
